export default __webpack_public_path__ + "static/media/web-full.26223c4a.avif";